import { useMutation } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";

interface RequestDocumentParams {
  estateId: number;
  documentType: string;
  contactId: number;
  notification: {
    recipient_email: string;
    requester_name: string;
    inviter_first_name: string;
    invitee_first_name: string;
    decedent_name: string;
    document_label: string;
    personal_note?: string;
    user_id: number;
  };
}

export function useRequestDocument() {
  return useMutation({
    mutationFn: async (params: RequestDocumentParams) => {
      const { data, error } = await supabase.functions.invoke("documents/request", {
        body: {
          estate_id: params.estateId,
          requested_document_type: params.documentType,
          recipient_contact_id: params.contactId,
          notification: params.notification,
        },
      });

      if (error) throw error;
      return data as { session_id: number; access_token: string };
    },
  });
}
